export default "__VITE_ASSET__CkDhwFeM__"